import React from 'react'

/* Generate favicon in https://www.favicon-generator.org/ */
/* eslint @typescript-eslint/no-require-imports: "off" */
const HelmetSet = () => (
    <>
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-57x57.png')} sizes="57x57" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-60x60.png')} sizes="60x60" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-72x72.png')} sizes="72x72" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-76x76.png')} sizes="76x76" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-114x114.png')} sizes="114x114" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-120x120.png')} sizes="120x120" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-144x144.png')} sizes="144x144" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-152x152.png')} sizes="152x152" />
        <link rel="apple-touch-icon" href={require('@App/assets/favicon/apple-icon-180x180.png')} sizes="180x180" />
        <link
            rel="icon"
            type="image/png"
            href={require('@App/assets/favicon/android-icon-192x192.png')}
            sizes="192x192"
        />
        <link rel="icon" type="image/png" href={require('@App/assets/favicon/favicon-32x32.png')} sizes="32x32" />
        <link rel="icon" type="image/png" href={require('@App/assets/favicon/favicon-96x96.png')} sizes="96x96" />
        <link rel="icon" type="image/png" href={require('@App/assets/favicon/favicon-16x16.png')} sizes="16x16" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="@App/assets/favicon/ms-icon-144x144.png" />
    </>
)

export default HelmetSet
